import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Logo from 'react-icons/lib/ti/flash-outline'

import { authLogin } from 'containers/Auth/actions'
import { fetchMe } from 'containers/Account/actions'
import FormLogin from './form-login'

class Login extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pending: false,
    }
  }

  _onSubmit = (payload) => {
    const { dispatch } = this.props

    this.setState({
      pending: true,
    })

    dispatch(authLogin(payload))
      .then((res) => {
        if (res.error) {
          this.setState({
            pending: false,
          })
        } else {
          dispatch(fetchMe())
            .then((res2) => {
              if (res2.error) {
                this.setState({
                  pending: false,
                })
              } else {
                // redirect to '/'
                this.context.router.replace('/')
              }
            })
        }
      })
  }

  render() {
    const { pending } = this.state
    const { __error } = this.props

    return (
      <div className="overlay overlay--login">
        <div className="overlay-dialog overlay-dialog--login" tabIndex="-1">
          <div className="overlay-content">
            <h3 className="overlay-title">
              <div className="icon"><Logo /></div>
              <div className="text"><span className="accent">ISMIS </span>- EDP</div>
            </h3>
            { !!__error && <p className="text-danger text-center italic"><small>{__error}</small></p> }
            <FormLogin
              onSubmit={this._onSubmit}
              pending={pending}
            />
          </div>
          <div className="overlay-actions">
            <p className="text-muted">
              <small>
                <strong>Integrated School Management <br />
                  and Information System
                </strong><br />
                Bohol Island State University
              </small>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

Login.contextTypes = {
  router: PropTypes.object,
}

Login.propTypes = {
  __error: PropTypes.string,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __error: state.auth.get('error'),
  }
}

export default connect(mapStateToProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/Auth/Login/index.js